/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './codemirror-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../src/app/shared/panel/panel.component';
import * as i4 from '../shared/codemirror/codemirror.component.ngfactory';
import * as i5 from '../../../../src/app/shared/codemirror/codemirror.component';
import * as i6 from '../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../src/app/shared/grid/grid.component';
import * as i8 from '../../../../src/app/codemirror/codemirror-demo.component';
const styles_CodemirrorDemoComponent:any[] = [i0.styles];
export const RenderType_CodemirrorDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CodemirrorDemoComponent,data:{}});
function View_CodemirrorDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),{showHeader:[0,
          'showHeader']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),0,2,'header',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['Codemirror'])),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-codemirror',
          ([] as any[]),(null as any),(null as any),(null as any),i4.View_CodemirrorComponent_0,
          i4.RenderType_CodemirrorComponent)),i1.ɵdid(114688,(null as any),0,i5.CodemirrorComponent,
          [i1.ElementRef],{value:[0,'value']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = true;
    _ck(_v,1,0,currVal_3);
    const currVal_4:any = _co.value;
    _ck(_v,6,0,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_CodemirrorDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,1,{templates:1}),(_l()(),i1.ɵand(0,[[1,2]],(null as any),0,
          (null as any),View_CodemirrorDemoComponent_1))],(null as any),(null as any));
}
export function View_CodemirrorDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_CodemirrorDemoComponent_0,
      RenderType_CodemirrorDemoComponent)),i1.ɵdid(49152,(null as any),0,i8.CodemirrorDemoComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const CodemirrorDemoComponentNgFactory:i1.ComponentFactory<i8.CodemirrorDemoComponent> = i1.ɵccf('ng-component',
    i8.CodemirrorDemoComponent,View_CodemirrorDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY29kZW1pcnJvci9jb2RlbWlycm9yLWRlbW8uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY29kZW1pcnJvci9jb2RlbWlycm9yLWRlbW8uY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9jb2RlbWlycm9yL2NvZGVtaXJyb3ItZGVtby5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY29kZW1pcnJvci9jb2RlbWlycm9yLWRlbW8uY29tcG9uZW50LnRzLkNvZGVtaXJyb3JEZW1vQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFkbWluLWdyaWQ+PG5nLXRlbXBsYXRlPjxhZG1pbi1wYW5lbCBbc2hvd0hlYWRlcl09XCJ0cnVlXCI+PGhlYWRlcj48aDM+Q29kZW1pcnJvcjwvaDM+PC9oZWFkZXI+PGFkbWluLWNvZGVtaXJyb3IgW3ZhbHVlXT1cInZhbHVlXCI+PC9hZG1pbi1jb2RlbWlycm9yPjwvYWRtaW4tcGFuZWw+PC9uZy10ZW1wbGF0ZT48L2FkbWluLWdyaWQ+IiwiPG5nLWNvbXBvbmVudD48L25nLWNvbXBvbmVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXlCO01BQUE7VUFBQTthQUFBO1VBQUEsOEJBQWlDO1VBQUE7TUFBUTtVQUFBLDBEQUFJO1VBQUEsaUJBQXdCO1VBQUE7MkNBQUEsVUFBQTtVQUFBOztJQUF4RDtJQUFiLFdBQWEsU0FBYjtJQUF1RjtJQUFsQixXQUFrQixTQUFsQjs7SUFBckU7SUFBQTtJQUFBO0lBQUEsV0FBQSw2QkFBQTs7OztvQkFBekI7TUFBQTthQUFBO2FBQUEsNEJBQVk7VUFBQTs7O29CQ0FaO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/codemirror/codemirror-demo.component.ngfactory.ts